import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'src/store'
import Footer from 'src/components/Footer'
import history from 'src/config/routes/history'
import images from 'src/config/images'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from './styles'
import ForgotPassword from './forgot-password'
import Login from './Login'

function Auth() {
  const { auth, me } = useSelector((state: ApplicationState) => ({
    auth: state.auth,
    me: state.me
  }))

  const [loading, setLoading] = useState<boolean>(false)
  const [loadingOrganization, setLoadingOrganization] = useState<boolean>(false)
  const [mainScreen, setMainScreen] = useState<boolean>(true)

  function toggle() {
    setMainScreen(!mainScreen)
  }

  useDocumentTitle('web.login.action-login')
  const [username, setUsername] = useState<string>('')

  function shareUsername(value?: string) {
    if (value === undefined) {
      return username
    }
    setUsername(value)
  }

  useEffect(() => {
    if (auth.access_token && me.organization) {
      history.push(
        me.organization.tenant &&
          me.organization.tenant.tenant_type === 'AGENCY'
          ? '/agencies/issuances'
          : '/my-requests'
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (auth.loading !== loading) {
      setLoading(auth.loading)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.loading])

  useEffect(() => {
    if (me.user && me.loading.organization !== loadingOrganization) {
      setLoadingOrganization(me.loading.organization)

      if (!me.loading.organization && !me.error.organization) {
        history.replace(
          me.organization.tenant &&
            me.organization.tenant.tenant_type === 'AGENCY'
            ? '/agencies/issuances'
            : '/my-requests'
        )
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me.loading.organization])

  return (
    <CSS.Container>
      <CSS.InitialLogo
        alt="web.login.img.alt"
        src={images.logo}
        title="web.login.img.title"
      />
      {mainScreen ? (
        <Login
          // loading={auth.loading || loadingOrganization}
          shareUsername={shareUsername}
          toggle={toggle}
        />
      ) : (
        <ForgotPassword
          loading={auth.loading || loadingOrganization}
          shareUsername={shareUsername}
          toggle={toggle}
        />
      )}
      <Footer />
    </CSS.Container>
  )
}

export default Auth
